import {IChannel, IDocument, IProduct} from '../models';
import { getIncludedResource } from '../util';

export function fromJsonApi(data, included: any[]): IChannel {
  const {
    name,
    channel_type: channelType,
    key,
    whitelabel,
    metadata,
  } = data.attributes;

  const products = getIncludedResource(data, included, 'products', true).map((resource): IProduct => {
    const {
      name,
      product_type: productType,
      product_code: productCode,
      status,
      summary,
      description,
      icon,
      metadata,
      documents,
    } = resource.attributes;

    return {
      id: resource.id,
      name,
      productType,
      productCode,
      status,
      summary,
      description,
      icon,
      metadata,
      documents,
    };
  });

  const productDocuments = getIncludedResource(data, included, 'product_documents', true).map((resource): IDocument => {
    const {
      name,
      file_path: filePath,
      short_name: shortName,
      display_name: displayName,
    } = resource.attributes;

    return {
      id: resource.id,
      name,
      filePath,
      shortName,
      displayName,
    };
  });

  return {
    id: data.id,
    name,
    channelType,
    key,
    whitelabel,
    products,
    productDocuments,
    baseName: metadata.base_name,
    phone: metadata.phone,
    footer: metadata.footer,
    openingHours: metadata.opening_hours,
    offlineSchedule: metadata.offline_schedule,
    gtmId: metadata.gtm_id,
    channelLogo: metadata.channel_logo,
    additionalLogo: metadata.additional_logo,
    steps: metadata.steps,
    cseScript: metadata.cse_script,
    live: metadata.live,
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/transformers/channels.ts